import * as React from 'react'
import { BankOutlined, SafetyCertificateOutlined } from '@ant-design/icons'
import { Button, Input, List, Modal, PageHeader, Row } from 'antd'
import { Menu, Space, Typography, Tooltip, Spin } from 'antd'

import { DataNode } from 'antd/lib/tree'

import { IConfigurazioneService } from '../../services/ConfigurazioneService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { AccessoCcModel, CatDataNode, ContiCorrentiModel, ContoCorrenteModel } from '../../models/ConfigurazioneModels'
import { ModalCategoria, OperationType } from './ModalCategoria'
import { EsempioCategorie } from './EsempioCategorie'
import Operation from 'antd/lib/transfer/operation'
import Search from 'antd/lib/input/Search'
import { TTAvatar } from '../shared/TTAvatar'
import { ModelBase } from '../../models/ModelBase'
import { IYapilyService } from '../../services/YapilyService'
import { YapilyFlowModel } from '../../models/YapilyModels'
import { RouteComponentProps, withRouter } from 'react-router'
import { TTFormItem } from '../shared/TTFormItem'
const { Text } = Typography

class PageYapilyConsensiState extends YapilyFlowModel {
    PsuIdMandatory: boolean
    PsuCorporateIdMandatory: boolean
    PsuIpAddressMandatory: boolean
}

interface YapilyPropos {
    id: string
    goto: (model: PageYapilyConsensiState) => void
}

export class ConsensiContent extends React.Component<YapilyPropos, PageYapilyConsensiState> {

    service: IYapilyService

    constructor(props) {
        super(props)
        this.state = new PageYapilyConsensiState()
        this.service = container.get(SERVICE_IDENTIFIER.YAPILY_SERVICE)
        // const id = this.props.match.params.id
    }

    async componentDidMount() {
        let ccId = this.props.id
        let result = await this.service.ConsensiTesto(ccId)
        if (result.IsValid == true) {
            this.setState({
                IdContoCorrente: ccId,
                Testo: result.Testo,
                PsuIdMandatory: result.PsuIdMandatory,
                PsuId: result.PsuId,
                PsuCorporateIdMandatory: result.PsuCorporateIdMandatory,
                PsuCorporateId: result.PsuCorporateId,
                PsuIpAddressMandatory: result.PsuIpAddressMandatory
            })
        }

    }

    onclick = async () => {
        let model = this.state
        this.props.goto(model)
    }

    render() {
        return (
            <PageHeader title="Consensi">
                <div dangerouslySetInnerHTML={{ __html: this.state.Testo }} />
                {this.state.PsuCorporateIdMandatory ?
                    <div>
                        <br /><br />
                        <p>Il servizio richiede di conoscere il tuo Codice Cliente</p>
                        <TTFormItem label="PsuCorporateId" required={true }>
                            <Input ref={this.state.PsuCorporateId} onChange={e => this.setState({ PsuCorporateId: e.target.value })} />
                        </TTFormItem>
                    </div> : <></>
                }
                {this.state.PsuIdMandatory ?
                    <div>
                        <br /><br />
                        <p>Il servizio richiede di conoscere il tuo Codice Cliente</p>
                        <TTFormItem label="PsuId" required={true }>
                            <Input ref={this.state.PsuId} onChange={e => this.setState({ PsuId: e.target.value })} />
                        </TTFormItem>
                    </div> : <></>
                }
                <Button type="primary" icon={<SafetyCertificateOutlined />} key="consenso" size="small"
                    onClick={()=>this.onclick()}>&nbsp;Prosegui</Button>
            </PageHeader>
        )
    }
}
